import React from 'react'

const AuthContext = React.createContext(null);

export const AuthProvider = ({ userData, children }) => {
  let [user, setUser] = React.useState(userData);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => React.useContext(AuthContext);

export const errorHandling = (error, cb) =>{    
    
  if(error.response.status === 401){
    console.log(error.response.statusText)
    cb(error.response)
  }
  console.log("Fetsch ends with an Error", error.toJSON())    
}
